if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'keyup',
        (evt) => evt.code === 'Escape' && this.close()
      );

      this.closest('.js-drawer-container').addEventListener('click', (event) => {
        event.stopPropagation();
      });

      this.closest('.js-drawer').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();

      this.detachSwipeClose = window.attachDrawerSwipeClose?.(this, {
        position: this.dataset.drawerPosition || 'right',
        onClose: () => this.close(),
      });
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
        this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.closest('.js-drawer').classList.add('animate', 'active');
      });

      document.body.classList.add('cart-is-open');
      setDrawerOpen(this, true);
      window.dispatchEvent(new CustomEvent('cart-drawer-open'));
    }

    close() {
      this.closest('.js-drawer').classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('cart-is-open');
      setDrawerOpen(this, false);
      this.updateURLParam();
    }

    updateURLParam() {
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);
      params.delete('openCart');
      window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`);
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute(
          'aria-controls',
          cartDrawerNote.nextElementSibling.id
        );
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget.closest('details').hasAttribute('open')
        );
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState, { open = true } = {}) {
      this.productId = parsedState.id;
      const hadFocus = this.contains(document.activeElement);

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        const html = parsedState.sections?.[section.id];

        if (!sectionElement || !html) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(
          html,
          section.selector
        );
      });

      if (hadFocus && !this.contains(document.activeElement)) {
        this.querySelector('.js-drawer-inner')?.focus();
      }

      if (!open) return;

      setTimeout(() => {
        this.open();
      });
    }

    announce(message) {
      setTimeout(() => {
        const announcement = this.querySelector('#CartDrawer-Announcement');
        if (announcement) announcement.textContent = message;
      }, 300);
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: this.dataset.id,
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: document.querySelector('cart-drawer').dataset.id,
          selector: '.js-drawer-inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }
  }

  customElements.define('cart-drawer-items', CartDrawerItems);
}

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get('openCart') === 'true') {
    openCartDrawer();
  }
});

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.open();
  }
}
